<template>
  <div>
    <!-- ##### Header Area Start ##### -->
    <header class="header-area">
      <!-- Top Header Area Next Big Event -->
      <!-- <div class="top-header">
        <div class="container h-100">
          <div class="row h-100">
            <div class="col-12 h-100">
              <div class="top-header-content h-100 d-flex align-items-center justify-content-end">
                <div class="next-events-countdown d-flex align-items-center">
                  <p>Próximo Servicio:</p>
                  <counter />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- Navbar Area -->
      <div class="faith-main-menu">
        <div class="classy-nav-container breakpoint-off">
          <div class="container">
            <!-- Menu -->
            <nav class="classy-navbar justify-content-between" id="faithNav">
              <!-- Logo -->
              <router-link class="nav-brand" to="/">
                <img src="@/assets/logo.png" width="70" alt />
              </router-link>
              
              <!-- Navbar Toggler -->
              <div class="classy-navbar-toggler" href="toggler">
                <span class="navbarToggler" ref="toggle">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </div>

              <!-- Menu -->
              <div class="classy-menu">
                <!-- Close Button -->
                <div class="classycloseIcon">
                  <div class="cross-wrap">
                    <span class="top"></span>
                    <span class="bottom"></span>
                  </div>
                </div>

                <!-- Nav Start -->
                <div class="classynav">
                  <ul>
                    <li @click="$refs.toggle.click()">
                      <router-link to="/"  active-class="active-menu" exact>Inicio</router-link>                      
                    </li>
                    <li @click="$refs.toggle.click()">
                      <router-link to="/church" active-class="active-menu">Iglesia</router-link>                      
                    </li>
                    <li @click="$refs.toggle.click()">
                      <router-link to="/pastors" active-class="active-menu">Pastores</router-link>                      
                    </li>
                    <li @click="$refs.toggle.click()">
                      <router-link to="/missions" active-class="active-menu">Misiones</router-link>                      
                    </li>
                    <li @click="$refs.toggle.click()">
                      <router-link to="/bq" active-class="active-menu" exact>
                         {{w > 1024 ?  'Memorización Bíblica' : 'BQ'}} 
                      </router-link>                                            
                    </li>
                    <li @click="$refs.toggle.click()">
                      <router-link to="/radio" active-class="active-menu" exact>Radio</router-link>                                            
                    </li>
                    <li @click="$refs.toggle.click()">
                      <router-link to="/homeschool" active-class="active-menu" exact>Homeschool</router-link>                                            
                    </li>
                    <li @click="$refs.toggle.click()">
                      <router-link to="/sermons" active-class="active-menu" exact>Servicios</router-link>                                            
                    </li>
                    <li @click="$refs.toggle.click()">
                      <router-link to="/foundation" active-class="active-menu" exact>Fundamentos Cristianos</router-link>                                            
                    </li>
                    <li @click="$refs.toggle.click()">
                      <router-link to="/contact" active-class="active-menu" exact>Contacto</router-link>                                            
                    </li>
                  </ul>

                  <!-- Search Button -->
                  <!-- <div class="search-btn">
                    <i class="fa fa-search" aria-hidden="true"></i>
                  </div> -->

                  <!-- Donate Button -->
                  <!-- <div class="donate-btn">
                    <a href="#">Donaciones</a>
                  </div> -->
                </div>
                <!-- Nav End -->
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>    
  
  </div>
  
</template>

<script>
import ExternalScripts from "@/components/ExternalScripts";
import Counter from "@/components/Counter";

export default {
  props: ["nextWorship"],
  components: { ExternalScripts, Counter },
  computed: {
    w: function () {
      const w = window.innerWidth;      
      return w;
    },
  },
  methods: {
    toggle() {
      this.$refs.toggler.click();
    },
  },
};
</script>

<style lang="css" scoped>
.active-menu {
  color: #ffffff;
  background-color: #ac8a74 !important;
}
.active-menu a {
  color: #ffffff;
}
.classy-menu {
  position: absolute;
  right: 10px;
}
</style>